import {
  Flex,
  
  Text,
  Box,
  Image,
  useMediaQuery,
  
} from "@chakra-ui/react";

import React from "react";

import Picture from "./picture";


import Terminal from "./Terminal";


function About() {
  const [isNotSmall] = useMediaQuery("(min-width: 1100px)");
  
  return (
    <div
      style={
        { display: "flex" ,justifyContent:'center'}
          
      }
      id="about"
    >
      <Flex
      
        direction={"column"}

        alignItems={"center"}


      >
        <Text
        margin={10}
            fontSize={isNotSmall ? "5xl" : "4xl"}
            fontWeight={"thin"}
            bgGradient={"linear(to-r,teal.400, cyan.400)"}
            bgClip={"text"}
          >
            {"About Me"}
          </Text>
        <Box margin={'20px'} pl={'20px'} pr={'20px'}  display={'flex'} width={'100vw'} alignItems={'center'}  justifyContent={'center'} gap={'40px'} flexDirection={isNotSmall ? 'row':'column'}>
          {/* <InstantPhoto image="https://images.unsplash.com/photo-1648142618804-92f908f93c10" /> */}
          
                 <Picture />
          <Terminal />
          
        </Box>        
      </Flex>

      {/* {isNotVerySmall ? <Box
        style={isNotSmall ? { width: "500px", backgroundColor:'red'} : { width: 250 }}
        m={!isNotSmall ? 10 : 10}
      >
        
      </Box> : null} */}
    </div>
  );
}

export default About;
